module.exports = __webpack_public_path__ + "img/首页未定栏目2.bd97ebe2.jpg";